<template>
  <div
    v-if="notification.show"
    class="message is-primary is-light is-outlined is-rounded mt-6 mb-5"
    data-cy="notifications-client">
    <header class="message-header">
      <div class="fa-2x mr-2">
        <i class="fa-solid fa-bell fa-shake" />
      </div>
      <p>{{ notification.title }}</p>
      <b-button
        class="toggleButton is-rounded ml-2"
        size="is-small"
        :aria-expanded="notificationCollapse"
        aria-controls="notification"
        @click="notificationCollapse = !notificationCollapse">
        <i
          :class="{ 'fa-angle-down': !notificationCollapse, 'fa-angle-up': notificationCollapse}"
          class="fas"
          aria-hidden="true" />
      </b-button>
    </header>
    <b-collapse
      v-model="notificationCollapse"
      aria-id="notification"
      class="message-body"
      animation="slide">
      <div class="content p-4 has-text-centered is-block">
        <p class="mb-0">{{ notification.text }}</p>
        <a
          v-if="notification.url!==''"
          id="notification-url"
          href="#notification-url"
          class="button is-text is-small mt-0"
          @click="clickEvent(notification.url)">
          <span class="icon">
            <i class="fas fa-external-link" />
          </span>
          <span>{{ notification.textBtn }}</span>
        </a>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import { FeatureToggleNotifications } from '@/application/services/feature-toggle-notifications';
import { getFeatureToggleByName } from '@/application/services/api-clients/features-toggles';
import { publish } from 'creditu-events-lib';
import { NotificationLinkClicked } from '@/domain/events/notification-link-clicked';
import currentUser from '@/ui/mixins/current-user';
import locale from '@/ui/mixins/locale';

export default {
  name: 'Notifications',
  mixins: [currentUser, locale],
  data() {
    return {
      notification: {
        show: false,
        title: '',
        text: '',
        url: '',
        textBtn: ''
      },
      notificationCollapse: false,
      currentUserRol: this.currentUser().user.rol,
      currentUserId: this.currentUser().user._id
    };
  },
  async mounted() {
    await this.loadNotifications();
  },
  methods: {
    async loadNotifications() {
      try {
        if (this.currentUserRol === 'CLIENT') {
          const notifications = new FeatureToggleNotifications(getFeatureToggleByName);
          const dataNotifications = await notifications.getNotification();
          this.notification.title = dataNotifications.options[0].value;
          this.notification.text = dataNotifications.options[1].value;
          this.notification.url = dataNotifications.options[2].value;
          this.notification.textBtn = dataNotifications.options[3].value;
          this.notification.show = dataNotifications.isActive;
        }
      } catch (e) {
        this.$log.error(`error getting feature toggle notifications. Cause: ${e.message}`);
      }
    },
    async clickEvent(url) {
      try {
        publish(new NotificationLinkClicked(
          {
            currentUserId: this.currentUserId,
            type: 'url'
          },
          {
            country: this.locale(),
            origin: 'INTERNAL-FRONTEND',
            component: 'NOTIFICATIONS-CLIENTS'
          }
        ));
      } catch (e) {
        this.$log.error('error publishing event NotificationLinkClicked', e);
      }
      window.open(url, '_blank');
    }
  }
};
</script>
<style scoped>
.message {
  border-radius: 0 0 20px 20px;
}

.message.is-primary .message-header {
  border-radius: 20px;
  background-color: #d6fafa;
  color: #00947e;
  font-weight: normal;
}

.message-body {
  padding: 0;
}

.message-header button {
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -ms-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
}

.toggleButton {
  -webkit-appearance: none;
  background-color: rgba(0, 173, 168, 0.2);
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  -webkit-box-flex: 0;
  height: 38px;
}
</style>
